import { track } from "../track";

export const trackSubscriptionCancelScs = () =>
  track({ event: "subscription_cancel_scs" });
